import {
  AmountMobileCell,
  CheckboxCell,
  HeaderCheckboxCell,
  IndicatorCell,
  InputCell,
  PayableMobileCell,
} from '../containers/MakeRecurringPaymentContainer/steps/RecurringPaymentScheduleStep/CustomCells';
import formatCurrency from './formatCurrency';

export const getContractStatus = (contract, t) => (contract.isFullyPaid
  ? t('recurrPayment.msgs.fullPaid', { policyNumber: contract.policyNumber })
  : null);

export const desktopTableColumns = (contract, handleUpdateContract, translation, classes) => [
  {
    customCell: (row, cell) => CheckboxCell(row, cell, classes),
    headerCustomCell: (cell) => HeaderCheckboxCell(cell, contract, handleUpdateContract, classes),
  },
  {
    customCell: (row) => IndicatorCell(row),
  },
  {
    title: 'recurrPayment.cols.date',
    property: 'date',
    format: (value) => value,
  },
  {
    title: 'recurrPayment.cols.amount',
    property: 'amount',
    format: (v) => `${formatCurrency(v)} ${translation('currency.AMD')}`,
  },
  {
    title: 'recurrPayment.cols.payable',
    property: 'payable',
    customCell: (row, cell) => InputCell(row, cell, contract, handleUpdateContract),
  },
  {
    title: 'recurrPayment.cols.status',
    property: 'status',
    format: (value) => translation(value),
  },
];

export const desktopTableColumnsForAttachCard = (translation) => [
  {
    customCell: (row) => IndicatorCell(row),
  },
  {
    title: 'recurrPayment.cols.date',
    property: 'date',
    format: (value) => value,
  },
  {
    title: 'recurrPayment.cols.amount',
    property: 'amount',
    format: (v) => `${formatCurrency(v)} ${translation('currency.AMD')}`,
  },
  {
    title: 'recurrPayment.cols.payable',
    property: 'payable',
    format: (v) => `${formatCurrency(v)} ${translation('currency.AMD')}`,
  },
  {
    title: 'recurrPayment.cols.status',
    property: 'status',
    format: (value) => translation(value),
  },
];

export const mobileTableColumns = (translation, isDeviceLgSize, classes) => [
  {
    headerCustomCell: (row, cell) => CheckboxCell(row, cell, classes, isDeviceLgSize),
  },
  {
    title: 'recurrPayment.cols.date',
    property: 'date',
    format: (value) => value,
  },
  {
    title: 'recurrPayment.cols.amount',
    property: 'amount',
    customCell: (row) => AmountMobileCell(row.amount),
  },
  {
    title: 'recurrPayment.cols.payable',
    property: 'payable',
    customCell: (
      row,
      cell,
      setEditableRowId,
      setEditableColumn,
      setOpen,
    ) => PayableMobileCell(row, cell, setEditableRowId, setEditableColumn, setOpen),
  },
  {
    title: 'recurrPayment.cols.status',
    property: 'status',
    format: (value) => translation(value),
  },
];

export const mobileTableColumnsForAttachCard = (translation) => [
  {
    title: 'recurrPayment.cols.date',
    property: 'date',
    format: (value) => value,
  },
  {
    title: 'recurrPayment.cols.amount',
    property: 'amount',
    customCell: (row) => AmountMobileCell(row.amount),
  },
  {
    title: 'recurrPayment.cols.payable',
    property: 'payable',
    customCell: (row) => AmountMobileCell(row.payable),
  },
  {
    title: 'recurrPayment.cols.status',
    property: 'status',
    format: (value) => translation(value),
  },
];

export const replaceMaskedContractNumber = (contractNumber) => contractNumber
  .replace('/', '')
  .replace(/\s+/g, '')
  .toUpperCase();

export const maskContract = (contractNumber) => `${contractNumber.slice(0, 2)}/${contractNumber.slice(2)}`;
